import { render, staticRenderFns } from "./delszjdDetail_homepage.vue?vue&type=template&id=04ab6f1b&scoped=true&"
import script from "./delszjdDetail_homepage.vue?vue&type=script&lang=js&"
export * from "./delszjdDetail_homepage.vue?vue&type=script&lang=js&"
import style0 from "./delszjdDetail_homepage.vue?vue&type=style&index=0&id=04ab6f1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab6f1b",
  null
  
)

export default component.exports